<template>
  <div v-if="content" class="dept-icon">{{ content }}</div>
</template>

<script>
export default {
  props: {
    department: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    content() {
      if (!this.department) {
        return "--";
      }
      return this.department.initials || "--";
    },
  },
};
</script>

<style lang="scss" scoped>
.dept-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--font-color);
  color: #fff;
  border-radius: 3px;
  font-size: 0.5rem;
  padding: 0 3px;
  height: 16px;
  min-width: 17px;
}
</style>
